export enum PartnerTypeEnum {
    NoPartner = 0,
    University = 1,
    ResearchInstitute = 2,
    Company = 3
}